import React from 'react';
import { Container, Box } from '@mui/material';
import PostSidebar from './PostSidebar';

const PostAccess = ({ children, currentStep, category, propertyType, assetType }) => {
  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, md: 8 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 2, md: 3 },
          justifyContent: 'center',
          maxWidth: '1400px',
          margin: '0 auto',
          px: { xs: 1, sm: 2, md: 2 },
        }}
      >
        {/* ✅ Sidebar with 380px width */}
        <PostSidebar
          currentStep={currentStep}
          category={category}
          propertyType={propertyType}
          assetType={assetType}
        />

        {/* Main Content */}
        {children}
      </Box>
    </Container>
  );
};

export default PostAccess;